import { asText, Content } from '@prismicio/client';
import { SliceComponentProps } from '@prismicio/react';

import {
  NotificationHeader,
  Notification as OxygenNotification,
} from '@preventx/oxygen';
import { RichText } from '@preventx/prismic-services';

// Services
import { applicationEnv } from '@/services/env/shared';

export type NotificationProps = SliceComponentProps<Content.NotificationSlice>;

const Notification = ({ slice }: NotificationProps) => {
  const { title, variant, content } = slice.primary;

  const { WebsiteUrl } = applicationEnv();

  return (
    <OxygenNotification
      addFlow
      colour={variant !== 'Default' ? variant : undefined}
    >
      <NotificationHeader>{asText(title)}</NotificationHeader>

      <RichText content={content} variant="default" websiteUrl={WebsiteUrl} />
    </OxygenNotification>
  );
};

export default Notification;
